var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['mx-auto px-4 sm:px-4 lg:px-8', _vm.marginVertical ? 'my-4' : '']},[_vm._t("default"),(_vm.loading)?_c('loading'):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }